import React, { FormEvent, useState } from 'react';
import { checkIsValid } from '../SignInModal/utils';

const FormInput = ({ options }: { options: FormInputOptions }) => {
  const {
    defaultValue = '',
    name,
    id,
    label,
    required = false,
    disabled = false,
    errorText,
    type = 'text',
    pattern,
    autocomplete,
    captionText,
    onInput,
    wrapperClasses = '',
    inputClasses = '',
    labelClasses = '',
    errorClasses = '',
    captionClasses = '',
    onFocus,
    onBlur,
    handleFormState,
    onChange,
    maxLength,
    showErrorOnBlur = true,
  } = options;

  const [value, setValue] = useState(defaultValue);
  const [errorState, setErrorState] = useState(false);
  const borderStyle = errorState ? 'error-border' : '';
  const handleErrorState = (errorState: boolean) => {
    handleFormState && handleFormState(!errorState);
    setErrorState(errorState);
  };

  return (
    <div className={`yoga-ui-text-input ${wrapperClasses}`}>
      <input
        type={type}
        id={id}
        className={`yoga-ui-input react-input ${borderStyle} ${inputClasses}`}
        defaultValue={defaultValue}
        name={name}
        required={required}
        disabled={disabled}
        placeholder={label}
        pattern={pattern}
        autoComplete={autocomplete}
        onBlur={(event) => {
          onBlur && onBlur(event);
          if (showErrorOnBlur) {
            handleErrorState(!checkIsValid(event.currentTarget.value, pattern));
          }
        }}
        onFocus={(event) => {
          onFocus && onFocus(event);
          setErrorState(false);
        }}
        onInput={(event) => {
          onInput && onInput(event);
          setErrorState(false);
          handleFormState && handleFormState(checkIsValid(event.currentTarget.value, pattern));
        }}
        onInvalid={(e) => {
          e.preventDefault();
          handleErrorState(true);
        }}
        value={value}
        onChange={(event) => {
          setValue(event.currentTarget.value);
          onChange && onChange(event);
          setErrorState(false);
          handleFormState && handleFormState(checkIsValid(event.currentTarget.value, pattern));
        }}
        maxLength={maxLength}
      />
      <label htmlFor={id} className={labelClasses}>
        {label}
      </label>
      {captionText ? <span className={`caption ${captionClasses}`}>{captionText}</span> : null}
      {errorText && errorState ? <span className={`error error-input-form ${errorClasses}`}>{errorText}</span> : null}
    </div>
  );
};

export default FormInput;

export interface FormInputOptions {
  id: string;
  label: string;
  defaultValue?: string;
  pattern?: string;
  autocomplete?: string;
  name?: string;
  type?: 'email' | 'text' | 'password' | 'search' | 'tel' | 'url' | 'date' | 'datetime-local' | 'time' | 'week';
  required?: boolean;
  disabled?: boolean;
  errorText?: string;
  captionText?: string;
  onInput?: (event: FormEvent<HTMLInputElement>) => void;
  wrapperClasses?: string;
  inputClasses?: string;
  labelClasses?: string;
  errorClasses?: string;
  captionClasses?: string;
  onFocus?: (event: FormEvent<HTMLInputElement>) => void;
  onBlur?: (event: FormEvent<HTMLInputElement>) => void;
  handleFormState?: (isValid: boolean) => void;
  onChange?: (event: FormEvent<HTMLInputElement>) => void;
  maxLength?: number;
  showErrorOnBlur?: boolean;
}
